// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "counter-cDUSx";
var _3 = "value-1A8Ze";
export { _1 as "__esModule", _2 as "counter", _3 as "value" }
export default { "__esModule": _1, "counter": _2, "value": _3 }
